var widget_default = {
  "card": "bl-5v",
  "link": "mE5K1",
  "container": "_6dfvb",
  "image": "-KCKL",
  "right": "_5hRwS",
  "cardLayout": "LB2F-",
  "content": "LlEN1",
  "title": "_4LrF4",
  "subtitle": "tGLVy",
  "button": "AleJM",
  "button_disabled": "LAX45",
  "buttonText": "hNppX",
  "slimLayout": "FzN0f",
  "contentText": "jgclk"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
